<style scoped lang="less">
  @import "../assets/my-style.less";

  #love-game {
    width: 100vw;
    height: 100vh;
    // background-color: #333333;
    // filter: grayscale(100%);

    .muPlayer {
      width: 0;
      height: 0;
      top: -20px;
      position: absolute;
      display: none;
    }

    .btn_audio {
      width: 80px;
      height: 80px;
      background: url("../assets/btn_audio.png");
      background-size: cover;
      position: absolute;
      top: 50px;
      right: 50px;
    }

    .abowMe {
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      position: absolute;
      width: 100%;
      height: 500px;
      top: 30%;
      .xtitle1 {
        height: 100%;
        width: 100%;
        text-align: left;
        
        // background: url(../resources/yashititle2.gif) no-repeat center center;
        // background-size: 300px 80px;
        align-content: left;
        text-indent: 80px;
        overflow: hidden;
        font-size: 60px;
        color: #ffffff;
        // line-height: 80px;
        position: absolute;
        display: block;
        text-shadow: 0 0 3px #000;
        font-family: zcmol;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        padding: 5px;
      }
    }

    .sure_btn {
       background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
       height: 90px;
       width:200px;
       position:absolute;
       bottom: -45%;
       left: 20%;

        align-content: center;
        overflow: hidden;
        font-size: 60px;
        color: #ffffff;
        // line-height: 80px;
        position: absolute;
        display: block;
        text-shadow: 0 0 2px #777;
        font-family: motto;
    }

    .no_btn {
       background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
       height: 90px;
       width:200px;
       position:absolute;
       bottom: -45%;
       right: 20%;

        align-content: center;
        overflow: hidden;
        font-size: 60px;
        color: #ffffff;
        // line-height: 80px;
        position: absolute;
        display: block;
        text-shadow: 0 0 2px #777;
        font-family: motto;
    }

    .middle {
      width: 100%;
      height: 260px;
      position: fixed;
      text-align: center;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      .xtitle {
        height: 160px;
        width: 100%;
        // background: url(../resources/yashititle2.gif) no-repeat center center;
        // background-size: 300px 80px;
        align-content: center;
        overflow: hidden;
        font-size: 80px;
        color: #ffffff;
        // line-height: 80px;
        position: absolute;
        display: block;
        text-shadow: 0 0 2px #777;
        font-family: motto;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
    }

    .player {
      position: fixed;
      overflow: hidden;
      .img-player1 {
        width: 100%;
        height: auto;
        background-position:center;
      }
      .img-player2 {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: cover;
        background-repeat:no-repeat;
        background-position:center;
      }
    }

    .bottom-title {
      width: 100%;
      height: 100px;
      font-family: motto;
      font-size: 50px;
      position: fixed;
      margin: 0 auto;
      bottom: 20px;
    }

    .home {
      width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      transition:all 2s ease-in;
      // background: rgba(0, 0, 0, 0.7);
      .bg1 {
        position: relative;
        width: 100%;
        height: 100%;
        background: url("../assets/bg1.jpg");
        background-size: cover;
        filter: grayscale(100%); 
      }
       .read {
          width: 150px;
          height: 150px;
          position: absolute;
          // margin-top: 120px;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          .flex;
          span {
            @size: 150px;
            width: @size;
            height: @size;
            color: #000;
            font-size: 108px;
            font-family: motto;
            background-color: @green;
            display: block;
            -webkit-border-radius: @size;
            -moz-border-radius: @size;
            border-radius: @size;
            .flex;
            &:hover {
              cursor: pointer;
              color: @comment_bg;
              border: 1px solid @comment_bg;
              background-color: initial;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
            }
          }
        }
    }

    .home_top {
      top: -100%;
    }
  }

</style>
<template>
  <div id="love-game">
    <audio class="muPlayer" :src="currentSrc" autoplay="" controls="" />
    <div class="player" :style="{'width': iWidth, 'height': iHeight, 'left': iLeft, 'top': iTop, 'transition': iTrans}">
      <img class="img-player1" :src="imgUrl1" />
    </div>
    <div class="btn_audio"></div>
    <div class="middle" v-show="!showAboutMe">
      <span class="xtitle">{{iText}}</span>
      <div class="sure_btn" v-show="showSure" @click="doYes">可以</div>
      <div class="no_btn" @click="doNo" v-show="showNo">no</div>
    </div>
    <div class="abowMe" v-show="showAboutMe">
      <span class="xtitle1">{{iText2}}</span>
     </div>
    <div :class="{'home_top': !showHome}" class="home">
          <div class="bg1"></div>
          <div class="read" @click="doClick"><span>读</span></div>
    </div>
  </div>
</template>
<script>
// import url1 from "@/assets/1.jpeg"
// import url2 from "@/assets/2.jpeg"
// import url3 from "@/assets/3.jpeg"
// import url4 from "@/assets/4.jpeg"
// import url5 from "@/assets/5.jpeg"
// import url6 from "@/assets/6.jpeg"
// import url7 from "@/assets/7.jpeg"
// import url8 from "@/assets/8.jpeg"
// import Aplayer from 'vue-aplayer'
export default {
    name: 'be_friend',
    data() {
      return {
        imgUrl1: "",
        imgUrl2: "",
        width: 1920 * (document.documentElement.clientHeight / 1080) * 1.2,
        height: document.documentElement.clientHeight * 1.2,

        iWidth: 1920 * (document.documentElement.clientHeight / 1080) * 1.2 +"px",
        iHeight: document.documentElement.clientWidth * 1.2 + "px",
        iLeft: "0px",
        iTop: "0px",
        iTrans: "none",

        showHome: true,

        isPlay: false,

        playerIndex: 0,
        isShow: false,
        timerId: false,

        currentSrc: "",

        showNo: false,
        showSure: false,

        showAboutMe: false,

        iTextTimerId: false,
        iTextIndex: 0,
        iText: "",
        text: [
          "hi 新一",
          "在这个夏天",
          "可以交个朋友？"
        ],

        
        iTextTimerId2: false,
        iTextIndex2: 0,
        iText2: "",
        text2: [
          {text:"Hi 新一", time: 4},
          {text:"这背景主题是 “菊次郎的夏天”, 我很喜欢的一首钢琴曲。主题，便是夏天。", time: 10},
          {text:"夏天是什么呢？", time: 4},
          {text:"夏天可以是冰箱里剩下的半个无籽西瓜, 混着冰块的冒泡可乐，外婆熬的冰镇绿豆汤；", time: 10},
          {text:"夏天也可以是雷阵雨后清新的空气, 池塘里一望无际的荷花, 烈日里此起彼伏的蝉鸣；", time: 10},
          {text:"夏天还可以是体育课上湿透了衣衫打篮球的男孩，数学课上昏昏欲睡的同桌，教室里发出咯咯声旋转的电风扇。", time: 15},
          {text:"每个人对“夏天”都有着不同的定义, 弹快点就是明媚灿烂的夏天, 弹慢点就是揣着心事慵懒的夏天。", time: 20},
        ],

        list3: [
          {
            title: '偏爱',
            artist: '未知',
            src: 'https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/music/pa.mp3',
          }
        ],

        playerData: [
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/1.jpeg", top: 0, left: -250, width: 1, height: 1, stay: 2, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/1.jpeg", top: 0, left: -700, width: 1, height: 1, stay: 6, move: 2, has: true},

          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/2.jpeg", top: 0, left: -300, width: 1, height: 1, stay: 2, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/2.jpeg", top: 0, left: -800, width: 1, height: 1, stay: 5, move: 4, has: true},

          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/3.jpeg", top: 0, left: -500, width: 1, height: 1, stay: 4, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/3.jpeg", top: 0, left: -500, width: 1.2, height: 1.2, stay: 6, move: 3, has: true},

          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/4.jpeg", top: 0, left: -650, width: 1.3, height: 1.3, stay: 2, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/4.jpeg", top: 0, left: -650, width: 1, height: 1, stay: 4, move: 3, has: true},

          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/5.jpeg", top: 0, left: -680, width: 1, height: 1, stay: 2, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/5.jpeg", top: 0, left: -0, width: 1, height: 1, stay: 5, move: 3, has: true},

          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/6.jpeg", top: 0, left: -800, width: 1, height: 1, stay: 2, move: 0, has: false},
          {url: "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/2022/6.jpeg", top: 0, left: -800, width: 1.2, height: 1.2, stay: 5, move: 3, has: true},
        ],
      }
    },
    methods: {
      reloadImg() {
        for (let data of this.playerData) {
          let image = new Image();
          // image.onload = () => {
          //     count++;
          // };
          console.log(data.url)
          image.src = data.url;
        }
      },
      doNo() {
       this.showNo = false 
      },
      doClick() {
        this.showHome = false;
        this.showText();
        // this.isPlay = true;
        this.currentSrc = "https://zcmol-1253645803.cos.ap-guangzhou.myqcloud.com/music/summer.mp3";
      },
      doYes() {
        this.showAboutMe = true
        this.showText2()
      },
      showText2() {
        let data = this.text2[this.iTextIndex2]
        this.iText2 = data.text

        this.iTextIndex2 += 1
        if (this.iTextIndex2 >= this.text2.length) {
          this.iTextIndex2 = 0
          clearTimeout(this.iTextTimerId2)
          return
        }

        clearTimeout(this.iTextTimerId2)
        this.iTextTimerId2 = setTimeout(() =>{
          this.showText2();
        }, data.time * 1000)
      },
      showText() {
        let text = this.text[this.iTextIndex]
        this.iText = text

        this.iTextIndex += 1
        if (this.iTextIndex >= this.text.length) {
          this.iTextIndex = 0
          this.showNo = true
          this.showSure = true
          clearTimeout(this.iTextTimerId)
          return
        }

        clearTimeout(this.iTextTimerId)
        this.iTextTimerId = setTimeout(() =>{
          this.showText();
        }, 4500)
      },
      player() {
        let data = this.playerData[this.playerIndex]
        // this.imgUrl1 = data.url
        // if (isShow) {
          // this.imgUrl1 = data.url
        // }
        // if (this.isShow) {
          // if (this.imgUrl1 != data.url) {
            this.imgUrl1 = data.url
        //   }
        // }
        // else {
        //   if (this.imgUrl2 != data.url) {
        //     this.imgUrl2 = data.url
        //   }
        // }

        // this.iTrans = "none"; 
        // this.iWidth = this.width + "px";
        // this.iHeight = this.height + "px";
        // this.iLeft = "0px";
        // this.iTop = "0px";

        // this.iTrans = "all 3s ease-in"; 
        let move = data.move
        if (!data.has ) {
          this.iTrans = "none"
        }
        else{
          this.iTrans = "all " + move + "s ease-in";
        }

        this.iWidth = (data.width * this.width) + "px";
        this.iHeight = (data.height * this.height) + "px";
        this.iLeft = data.left + "px";
        this.iTop = data.top + "px";
        let stay = data.move + data.stay
        // this.iTop = data.top + "px";

        this.playerIndex += 1
        if (this.playerIndex > this.playerData.length - 1) {
          this.playerIndex = 0;
        }

        clearTimeout(this.timerId)
        let duration = stay * 1000
        this.timerId = setTimeout(() => {
          this.isShow = !this.isShow
          this.player()
        }, duration)
      },
      getInfo(data) {
        return {
          width: (data.width * this.width) + "px",
          height: (data.height * this.height) + "px",
          left: data.left + "px",
          top: data.top + "px"
        }
      }
    },
    mounted() {
      // this.reloadImg()
      this.player() 
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BeFriend.vue